import React, { FC } from 'react';
import { Button, Tooltip } from 'antd';
import { CloudDownloadOutlined, PlusOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { FilterButton } from 'components';
import palette from 'palette';
import { stringifyUrlParams, useUrlParams } from 'hooks/use-url-params';
import { Modal } from 'types/modal';
import { StyledHeaderExtra } from './styles';

interface HeaderExtraProps {
  isFilterActive: boolean;
  onFilterOpen: () => void;
  onFilterClose: () => void;
  onExportButtonClick: () => void;
}

export const HeaderExtra: FC<HeaderExtraProps> = ({
  isFilterActive,
  onFilterOpen,
  onFilterClose,
  onExportButtonClick,
}) => {
  const { pathname } = useLocation();
  const { queryUrlParams } = useUrlParams({});
  const { t } = useTranslation();

  return (
    <StyledHeaderExtra>
      <Tooltip title={<span style={{ color: palette.black.b1 }}>{t('user.addUser')}</span>} color={palette.white.w1}>
        <Link to={{ pathname, search: stringifyUrlParams({ ...queryUrlParams, modal: Modal.NEW_USER }) }}>
          <PlusOutlined style={{ fontSize: 20, color: palette.black.b1 }} />
        </Link>
      </Tooltip>
      <Tooltip
        placement="bottomRight"
        title={<span style={{ color: palette.black.b1 }}>{t('user.exportUsers')}</span>}
        color={palette.white.w1}
      >
        <Button type="text" icon={<CloudDownloadOutlined />} onClick={onExportButtonClick} />
      </Tooltip>
      <FilterButton isFilterActive={isFilterActive} onOpen={onFilterOpen} onClose={onFilterClose} />
    </StyledHeaderExtra>
  );
};
